import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	icons: [],
}

function setIcons(state, action) {
	return {
		...state,
		icons: action.icons,
	}
}

function addIcon(state, action) {
	return {
		...state,
		icons: [
			...state.icons,
			{
				id: action.icon.id,
				status: action.icon.status,
			},
		],
	}
}

function removeIcon(state, action) {
	const iconId = action.iconId !== undefined ? action.iconId : action.icon.id
	return {
		...state,
		icons: state.icons.filter(icon => icon.id != iconId),
	}
}

const processingReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.PROCESSING_INITIALIZE_SUCCESS: {
			return setIcons(state, action)
		}
		case actionTypes.DRAW_IT_UPLOADER_UPLOAD_SUCCESS:
		case actionTypes.POLL_UPLOADER_UPLOAD_SUCCESS:
		case actionTypes.OEQ_UPLOADER_UPLOAD_SUCCESS:
		case actionTypes.QUIZ_UPLOADER_UPLOAD_SUCCESS:
		case actionTypes.GOOGLE_SLIDES_ACTIVITY_SAVED_FINISHED: {
			return addIcon(state, action)
		}
		case actionTypes.PROCESSING_ICON_SUCCESS:
		case actionTypes.PROCESSING_ICON_ERROR:
		case actionTypes.POLL_DELETE_REFERENCE_MEDIA:
		case actionTypes.OEQ_DELETE_REFERENCE_MEDIA:
		case actionTypes.DRAW_IT_DELETE_REFERENCE_MEDIA:
		case actionTypes.QUIZ_DELETE_REFERENCE_MEDIA:
		case actionTypes.GAME_UPLOAD_QUESTION_MEDIA_DELETE: {
			return removeIcon(state, action)
		}
		default: return state
	}
}

export default processingReducer
